export default __webpack_public_path__ + "static/media/hand-money.763d4243.svg";